
import { fromEvent, combineLatest } from 'rxjs'
import { map, scan, auditTime, distinctUntilChanged } from 'rxjs/operators'

const VISIBLE_CLASS = 'page--scrolling-upward'

export default class BackToTopController {
  constructor (options) {
    this._bindUIActions()
  }

  _bindUIActions () {
    const scrollEvents$ = fromEvent(window, 'scroll')
    const scrollY$ = scrollEvents$.pipe(
      map(e => {
        return window.scrollY
      }),
      auditTime(50)
    )

    const scrolled$ = scrollY$.pipe(
      map(scrollY => scrollY > 100),
      distinctUntilChanged()
    )

    const average = (array) => array.reduce((a, b) => a + b) / array.length
    const scrollYSoft$ = scrollY$.pipe(
      scan((lastPositions, position) => {
        lastPositions.push(position)
        return lastPositions.slice(-3)
      }, []),
      map((lastPositions) => average(lastPositions))
    )

    const lastTwoPositions$ = scrollYSoft$.pipe(
      scan((lastPositions, position) => {
        lastPositions.push(position)
        return lastPositions.slice(-2)
      }, [])
    )

    const pixelsScrolledUp$ = lastTwoPositions$.pipe(
      scan((pixels, lastTwoPositions) => {
        const delta = lastTwoPositions[1] - lastTwoPositions[0]
        if (delta > 0) {
          // Going down
          return 0
        } else {
          return pixels - delta
        }
      }, 0)
    )

    const goingUp$ = pixelsScrolledUp$.pipe(
      map(p => p > 50),
      distinctUntilChanged()
    )

    const buttonShowing$ = combineLatest(goingUp$, scrolled$).pipe(
      map(([goingUp, scrolled]) => goingUp && scrolled)
    )

    buttonShowing$.subscribe(buttonShowing => {
      if (buttonShowing) {
        document.body.classList.add(VISIBLE_CLASS)
      } else {
        document.body.classList.remove(VISIBLE_CLASS)
      }
    })
  }
}
